import { I_Scene } from '@containers/Home/types';
import dynamic from 'next/dynamic';
import { memo, useCallback, useState, useEffect } from 'react';
import { ThemeWallWrapper } from './styled';
import Cookies from 'js-cookie';

const Tour = dynamic(() => import('@containers/Home/components/Tour'), {
  ssr: false,
});
const ListScene = dynamic(() => import('./ListScene'), { ssr: false });
const Header = dynamic(() => import('./Header'));
const Controlbar = dynamic(() => import('./Controlbar'));
const PostScene = dynamic(() => import('./PostScene'));
const Map = dynamic(() => import('./Map.Container'));

interface Props {
  onNextScene: () => void;
  onChangeScene: (scene: I_Scene) => void;
}

const ThemeWall = memo(({ onNextScene, onChangeScene }: Props) => {
  const [isShow, setIsShow] = useState(false);
  const [isHide, setIsHide] = useState(false);
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    const savedIsHide = Cookies.get('isHide');
    const savedImageData = Cookies.get('imageData');

    setIsHide(savedIsHide === 'true');
    setImageData(savedImageData);
  }, []);
  const hideAnnotation = value => {
    setIsHide(value);
    Cookies.set('isHide', value.toString());
    if (value && imageData) {
      Cookies.set('imageData', imageData);
    }
  };

  const onSaveImageToCookie = () => {
    hideAnnotation(true);
  };

  const onToggleShow = useCallback(() => setIsShow(prev => !prev), []);

  return (
    <ThemeWallWrapper id="discover">
      <div className="discoverMap">
        <Header />

        <Tour onChangeScene={onChangeScene} onNextScene={onNextScene}>
          <Controlbar />
          <ListScene
            isShow={isShow}
            onToggleShow={onToggleShow}
            onChangeScene={onChangeScene}
          />
        </Tour>

        <PostScene isShowIntro={isShow} />
        <div className={`--annotation ${isHide === true ? 'hide' : ''}`}>
          <img src="/static/img/scene-note.png" alt="" />
          <div className="close" onClick={onSaveImageToCookie}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <Map />
      </div>
    </ThemeWallWrapper>
  );
});

export default ThemeWall;
